import React, { Component } from "react";

import { HtmlParserWrapper } from "Components/HtmlParserWrapper";
import ZCTouch from "../ZCTouch";
import PropsType from "prop-types";
import _ from "lodash";

import ZCMVideo from "./ZCMVideo";
import ZTagParser from "./ZCMHTMLTags/ZTagParser";
import ZCScroll from "../ZCScroll";

import "./ZCMsg.css";

class ZCMTemplates extends Component {
  static propTypes = {
    templates: PropsType.array,
    disabled: PropsType.bool,
  };

  static defaultProps = {
    templates: [],
    disabled: true,
  };

  constructor() {
    super();
    this.state = {
      page: 0,
    };
    this.tps = [];
  }

  componentDidMount() {
    this.setState((state, props) => ({
      ...props,
    }));
  }

  onMountScroll = (callbacks) => {
    this.MountScroll = callbacks;
  };

  static getDerivedStateFromProps(nextProps, prevStat) {
    if (prevStat !== nextProps) {
      return {
        ...nextProps,
      };
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _scrollIntoView(id, animated = true) {
    if (this.tps === null || !this.tps[id]) {
      return;
    }
    this.tps[id].scrollIntoView();
  }

  pageShift = (x) => {
    this.setState(
      (state, props) => ({
        page: Math.max(0, Math.min(state.page + x, state.templates.length - 1)),
      }),
      () => {
        this._scrollIntoView(this.state.page);
      }
    );
  };

  renderTpButtons(tclassname, buttons) {
    let { cssp, _onQuickReply, onPhoneClick, onWebClick, disabled } = this.state;

    let rendered = [];
    _.map(buttons, (o, i) => {
      let func = null;
      let last = i === buttons.length - 1;
      switch (o.type) {
        case "web":
          func = () => onWebClick(o.payload);
          break;
        case "phone":
          func = () => onPhoneClick(o.payload);
          break;
        default:
          func = () => _onQuickReply(o);
          break;
      }

      rendered.push(
        <div key={i} className={tclassname + "-btn " + (disabled ? "disabled " : "") + (last ? "last " : "")}>
          <ZCTouch cssPrefix={cssp} onPress={func} disabled={disabled}>
            <div className={tclassname + "-btn-text " + (disabled ? "disabled " : "") + (last ? "last " : "")}>{o.title}</div>
          </ZCTouch>
        </div>
      );
    });

    return rendered;
  }

  renderTemplates() {
    let { cssp, templates, HTMLEnabled, HTMLSpecialTagParser, iaddOns } = this.state;
    let rendered = [];
    let tclassname = cssp + " msg-tp";
    _.map(templates, (o, i) => {
      let text = "";
      if (o.text) {
        if (HTMLEnabled) {
          let parsed = <HtmlParserWrapper html={o.text} />;
          if (HTMLSpecialTagParser) {
            text = HTMLSpecialTagParser(cssp, parsed, iaddOns);
          } else {
            text = ZTagParser.Parse(cssp, parsed, iaddOns);
          }
        } else {
          text = o.text;
        }
      }

      let hasButtons = o.buttons && o.buttons.length > 0;
      let hasText = o.text && o.text !== "";

      rendered.push(
        <div key={i} className={tclassname} ref={(e) => (this.tps[i] = e)}>
          <div className={tclassname + "-title-border"}>
            <div className={tclassname + "-title"}>{o.title}</div>
          </div>
          <div className={tclassname + "-subtitle-border"}>
            <div className={tclassname + "-subtitle"}>{o.subtitle}</div>
          </div>
          {o.video ? (
            <div className={tclassname + (hasText || hasButtons ? "-video-border" : "-video-border-end")}>
              <div className={tclassname + "-video"}>
                <ZCMVideo {...this.state} video={o.video} />
              </div>
            </div>
          ) : (
            <div className={tclassname + (hasText || hasButtons ? "-img-border" : "-img-border-end")}>
              <div className={tclassname + "-img"}>
                <img src={o.image} alt="" draggable={false} />
              </div>
            </div>
          )}
          {hasText && (
            <div className={tclassname + (hasButtons ? "-text-border" : "-text-border-end")}>
              <div className={tclassname + "-text"}>{text}</div>
            </div>
          )}
          {hasButtons && this.renderTpButtons(tclassname, o.buttons)}
        </div>
      );
    });

    return rendered;
  }

  render() {
    let { cssp, templates } = this.state;
    return (
      <div className={cssp + " msg-tcontainer"}>
        {templates.length > 1 && (
          <div key={"left"} className={cssp + " msg-tcontainer-arrows"}>
            <ZCTouch cssPrefix={cssp} onPress={() => this.pageShift(-1)}>
              <i className="fas fa-chevron-left" />
            </ZCTouch>
          </div>
        )}
        <ZCScroll cssPrefix={cssp + " msg-tlist"} onMounted={this.onMountScroll}>
          {this.renderTemplates()}
        </ZCScroll>
        {templates.length > 1 && (
          <div key={"right"} className={cssp + " msg-tcontainer-arrows"}>
            <ZCTouch cssPrefix={cssp} onPress={() => this.pageShift(1)}>
              <i className="fas fa-chevron-right" />
            </ZCTouch>
          </div>
        )}
      </div>
    );
  }
}

export default ZCMTemplates;
